import * as React from 'react';

export interface ITabListTabContentProps {
  id?: string;
  navId?: string;
  index?: number;
  activeIndex?: number;
  children: React.ReactNode;
}

function TabListTabContent({ id = undefined, navId = undefined, index = undefined, activeIndex = undefined, children }: ITabListTabContentProps) {
  const isActive = index === activeIndex;

  return (
    <div id={id} className={`tab-pane ${isActive ? 'active' : ''}`} role="tabpanel" aria-labelledby={navId} hidden={!isActive} tabIndex={0}>
      {children}
    </div>
  );
}

export default TabListTabContent;
